import React, { Component, Fragment } from "react";
import Chart from "react-apexcharts";
import util from "../TesteNovoJSON/Util/util";
import Select from "./Select";
import SelectUnidade from "./SelectUnidade";


export default class Grafico extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: "Anual",
            modalidade: "5 Iniciação Profissional",
            unidade: "DR",
            metas: [],
            selectCampo: 0,
            nomeCampo: "Matrículas",
            dados: [], 
            realizados: [], 
            acumulado: {},
            selectUnidade: "1117489 Centro de Formação Profissional Professor Stenio Lopes",
            selectModalidade: "21 Qualificação Profissional",
            series: [
                {
                    name: "Pago",
                    data: []
                },
                {
                    name: "Gratuidade Regimental",
                    data: []
                },
                {
                    name: "Gratuidade Não-Regimental",
                    data: []
                }
            ],
            options: {
                chart: {
                    height: 350,
                    type: 'line',
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,
                        blur: 10,
                        opacity: 0.2
                    },
                    toolbar: {
                        show: false
                    }
                },
                colors: ['#77B6EA', '#545454', '#FEBC3B', "#51CBCE"],
                dataLabels: {
                    enabled: true,
                    formatter: function (value) {
                        return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                    },
                    background: {
                        enabled: true,
                        //foreColor: ['#77B6EA', '#545454', '#FEBC3B', 'transparent'],
                        borderWidth: 1,
                    },
                },
                stroke: {
                    curve: 'smooth'
                },
                title: {
                    text: 'Total',
                    align: 'left'
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'],
                        opacity: 0.5
                    },
                },
                markers: {
                    size: 1
                },
                xaxis: {
                    categories: ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"],
                    title: {
                        text: 'Mês'
                    }
                },
                yaxis: {
                    title: {
                        text: 'TOTAL'
                    },
                    //min: 5,
                    //max: 40,
                    //opposite: true,
                    labels: {
                        formatter: function (value) {
                            if (Number.isFinite(value)) {
                                return value.toLocaleString("pt-BR", { maximumFractionDigits: 2, style: 'decimal' });
                            }
                            else {
                                return 0
                            }
                        }

                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: -25,
                    offsetX: -5,
                    formatter: function(seriesName, opts) {
                        seriesName = seriesName === "Total" ? "Total" : seriesName;
                        return [seriesName]
                    }
                }
            }

        }
    }

    async componentDidMount() {
        this.calculaTipoPorMes();
    }

    calculaTipoPorMes = async (event) => {
        let valor = event ? event.target.value : null;
        let id = event ? event.target.id : null;

        let { selectUnidade, selectModalidade } = this.state;
        let { dados, realizados, acumulado } = await util.fetchDados(this.state.mesSelecionado, false);


        if(id === "selectUnidade") {
            selectUnidade = valor;
        }
        if (id === "selectModalidade") {
            selectModalidade = valor;
        }
        
        let indice = dados && dados.findIndex(unidade => unidade.unidade === selectUnidade);

        let realizado1 = new Array(12).fill(0);
        let realizado2 = new Array(12).fill(0);
        let realizado3 = new Array(12).fill(0);

        try {
            realizado1 = dados[indice] && dados[indice]["realizados"][selectModalidade] && dados[indice]["realizados"][selectModalidade]["matricula_regimental"]     ? dados[indice]["realizados"][selectModalidade]["matricula_regimental"]     : realizado1;  
            realizado2 = dados[indice] && dados[indice]["realizados"][selectModalidade] && dados[indice]["realizados"][selectModalidade]["matricula_nao_regimental"] ? dados[indice]["realizados"][selectModalidade]["matricula_nao_regimental"] : realizado2;
            realizado3 = dados[indice] && dados[indice]["realizados"][selectModalidade] && dados[indice]["realizados"][selectModalidade]["matricula_pago"]           ? dados[indice]["realizados"][selectModalidade]["matricula_pago"]           : realizado3;
        }
        catch(erro) {
        }

        this.setState({
            series: [
                {
                    name: "Pago",
                    data: realizado3
                },
                {
                    name: "Gratuidade Regimental",
                    data: realizado1
                },
                {
                    name: "Gratuidade Não-Regimental",
                    data: realizado2
                }
            ],
            options: {
                title: {
                    text: `Unidade`
                }
            },
            selectUnidade,
            selectModalidade,
            dados, 
            realizados, 
            acumulado
        });
    }

    informaCampo = (selectCampo) => {
        var propriedades = [
            "N.° de Turmas",
            "N.º de Alunos Turmas",
            "Carga Horária",
            "Mat. Residuais",
            "Mat. Novas",
            "Total Mat.",
            "Hora/aluno",
            "Carga H. Turma/Ano",
            "Necessidade de docente (8h)",
            "Necessidade de docente (7,2h)"
        ]
        return propriedades[selectCampo]
    }

    render() {
        return (
            <Fragment>

                <div className="row">
                    <div className="col-md-12">
                        <div className="card ">
                            <div className="card-header ">
                                <div className="row">
                                    <div className="col-md-6">
                                        <h5 className="card-title">{this.state.nomeCampo}</h5>
                                        <h6>{this.state.modalidade}</h6>
                                    </div>
                                    <div className="col-md-2">
                                    </div>
                                    <div className="col-md-2">
                                        <Select select={this.calculaTipoPorMes} campo="unidades" idComponente="selectUnidade" />
                                    </div>
                                    <div className="col-md-2">
                                        <Select select={this.calculaTipoPorMes} />
                                    </div>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="mixed-chart">
                                    <Chart options={this.state.options} series={this.state.series} type="line" height={"300"} />
                                </div>
                            </div>
                            <div className="card-footer ">
                                <hr />
                                <div className="stats">
                                    <i className="fa fa-history"></i> {new Date().toLocaleDateString("pt-br", { dateStyle: "full" })}
                                    {/*
                                    <span style={{ float: 'right' }}>
                                        <button className="btn btn-outline-primary btn-round btn-sm" style={{ fontSize: '0.500em' }}>
                                            Visão Unidades
                                        </button>
                                    </span>
                                    */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}